import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';

import { CertificationProviderStatusEnum } from 'app/library/certification-provider/enums/certification-provider-status.enum';
import {
    CreateCertification,
    CreateCertificationFailure,
    CreateCertificationSuccess,
    CreateInternalCertification,
    CreateInternalCertificationFailure,
    CreateInternalCertificationSuccess,
    DeleteCertification,
    DeleteCertificationFailure,
    DeleteCertificationSuccess,
    FetchCertifications,
    FetchCertificationsFailure,
    FetchCertificationsSuccess,
    UnsetCertifications,
    UpdateCertification,
    UpdateCertificationFailure,
    UpdateCertificationStatus,
    UpdateCertificationStatusFailure,
    UpdateCertificationStatusSuccess,
    UpdateCertificationSuccess,
} from '../actions';
import { Certification } from '../models/certification';
import { CertificationsState } from '../models/certifications.state';

@Injectable()
export class CertificationService {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getCertifications(): Certification[] {
        return this._store.selectSnapshot(CertificationsState.getFilteredEntities);
    }

    async fetchCertifications(pageSize: number, pageNumber: number, search: string, provider: string[], statuses: number[]): Promise<boolean> {
        this._store.dispatch(new FetchCertifications({ pageSize, pageNumber, search, provider, statuses }));

        return await this._actionHelper.race(FetchCertificationsSuccess, FetchCertificationsFailure).toPromise();
    }

    async createCertification(name: string, providerId: string, hasExpirationDate: boolean, targetCount?: number): Promise<boolean> {
        this._store.dispatch(new CreateCertification({ name, providerId, hasExpirationDate, targetCount }));

        return await this._actionHelper.race(CreateCertificationSuccess, CreateCertificationFailure).toPromise();
    }

    async createInternalCertification(name: string, providerId: string, validityPeriod: number, file: File, hasExpirationDate: boolean, targetCount?: number): Promise<boolean> {
        this._store.dispatch(new CreateInternalCertification({ name, providerId, validityPeriod, file, hasExpirationDate, targetCount }));

        return await this._actionHelper.race(CreateInternalCertificationSuccess, CreateInternalCertificationFailure).toPromise();
    }

    async updateCertification(id: string, name: string, validityPeriod?: number, hasExpirationDate?: boolean, targetCount?: number): Promise<boolean> {
        this._store.dispatch(new UpdateCertification({ id, name, validityPeriod, hasExpirationDate, targetCount }));

        return await this._actionHelper.race(UpdateCertificationSuccess, UpdateCertificationFailure).toPromise();
    }

    async deleteCertification(id: string): Promise<boolean> {
        this._store.dispatch(new DeleteCertification(id));

        return await this._actionHelper.race(DeleteCertificationSuccess, DeleteCertificationFailure).toPromise();
    }

    async updateCertificationStatus(id: string, status: CertificationProviderStatusEnum): Promise<boolean> {
        this._store.dispatch(new UpdateCertificationStatus({ id, status }));

        return await this._actionHelper.race(UpdateCertificationStatusSuccess, UpdateCertificationStatusFailure).toPromise();
    }

    unsetCertifications(): void {
        this._store.dispatch(new UnsetCertifications());
    }
}
